import { Value } from '@philips-internal/oswald-ui-core';

interface ForwardBalanceApprovalRequest {
  approvalSequence: number | string,
  approvalProcessSequence: number | string,
}

interface BalanceApprovalResponse {
  newSequenceProcess: number
}

interface FormData extends ForwardBalanceApprovalRequest, Record<string, Value> {}

const normalizeForwardBalanceApprovalBody = (approvalSequence: number | string, approvalProcessSequence: number | string): FormData => ({
  approvalSequence: approvalSequence,
  approvalProcessSequence: approvalProcessSequence,
});
  
export {
  normalizeForwardBalanceApprovalBody,
  BalanceApprovalResponse,
};
